import { memo, useCallback, useState, useEffect } from "react";

import Menu from "./Menu";
import LiveTvPage from "../liveTv/LiveTvPage";
import MoviesPage from "../movies/MoviesPage";
import PlaylistPage from "../playlist/PlaylistPage";
import SettingsPage from "../settings/SettingsPage";
import VideosPage from "../videos/VideosPage";

import "./MenuPage.scss";
import useStore from "@/src/hooks/useStore";
import LoginPopup from "@/src/popups/login/LoginPopup";
import PageLoading from "@/src/components/pageLoading/PageLoading";
import Storege from "@/src/services/storage/storage";
import PlaylistStorage from "@/src/services/playlists";
import { GetPlaylistContent, GetStartupPlaylist, IsPlayablePlaylist } from "@/src/services/content/content";
// import TimeLineEpg from "../liveTv/components/timeLineEpg/TimeLineEpg";

const MenuPage = ({ isVisible, onBack = () => { },error = false }) => {

    const [_, setAppBackground] = useStore("appBackground");

    const [selectedPage, setSelectedPage] = useState("LOADING");

    const [dataError, setdataError] = useState(error);

    const [playlists, setPlaylists] = useStore("playlists");
    // menu active page needs to be parent state for save previous page on back
    const [activePage, setActivePage] = useState("TV");

    useEffect(() => {
        
         const checkStatus = async () => {
             let page = !playlists.some(IsPlayablePlaylist) || dataError ? 'LOGIN' : 'MENU';

          if(dataError){

            // the account failed to load: it is removed and the login page asks for one
            // (a playlist that can't be played is never removed automatically)
            for(let i = 0; i < playlists.length; i++){

                    if (IsPlayablePlaylist(playlists[i])) await PlaylistStorage.remove(playlists[i].id);

            }
          }
        
            setSelectedPage(page);
        }

         checkStatus();

    }, [isVisible,dataError])




    const updateContent = async () => {
        
        setSelectedPage("LOADING");

        let selected = await GetStartupPlaylist(playlists);

        if (selected) {

            let res = await GetPlaylistContent(selected)

            if(res == 'errorLogout'){
              
                setdataError(true)
            }
         }
        
         setSelectedPage("MENU");
    }

    useEffect(() => {

        // only the way to the login page: the list also changes while a login is still loading its content,
        // and the login popup moves on to the menu itself once that is done
        if(!playlists.some(IsPlayablePlaylist)){

            setSelectedPage('LOGIN');

        }

    },[playlists])

    const showMenu = useCallback(() => {

        let page = !playlists.some(IsPlayablePlaylist) ? 'LOGIN' : 'MENU';

        
        if(page == 'MENU'){
           
            requestAnimationFrame(() => {
                
                setAppBackground("fullscreen");
            
            });
        
        }
        
        setSelectedPage(page);
       
    }, [playlists]);

    if (!isVisible) return null;
    
    return (
        <>
            {
                selectedPage == 'LOADING' && <PageLoading isVisible={true} />
            }
            {selectedPage == "MENU" && <Menu
                onBack={onBack}
                setSelectedPage={setSelectedPage}
                activePage={activePage}
                setActivePage={setActivePage}
                updateContent={updateContent}
            />}
            {selectedPage == "TV" && <LiveTvPage onBack={showMenu} />}
            {selectedPage == "MOVIES" && <MoviesPage onBack={showMenu} type="movies" />}
            {selectedPage == "SERIES" && <MoviesPage onBack={showMenu} type="series" />}
            {selectedPage == "PLAYLISTS" && <PlaylistPage onBack={showMenu} />}
            {selectedPage == "VIDEOS" && <VideosPage onBack={showMenu} />}
            {selectedPage == "SETTINGS" && <SettingsPage onBack={showMenu} />}
            {/* {selectedPage == "ACTIVATION" && <ActivationPopup isVisible={true} onBack={showMenu} />} */}
            {selectedPage == "LOGIN" && <LoginPopup isVisible={true} onBack={()=>{setSelectedPage("MENU")}} />}
            {/* <TimeLineEpg /> */}
        </>
    )
}

export default memo(MenuPage);